import moment from 'moment';
import camelcaseKeys from 'camelcase-keys';
import { buildWidgetUrlWithParameter, cloneDeep, getDistinctByProperty, removeDuplicates } from './helper';
import { DataOperators, Operators } from '../constants/appConstants';
import { BarChartUtility } from '../components/common/graph-utilities/barChart';
import { apiBatchRequest } from './api_service';
import { createApiUrl } from '../constants/api';
import store from '../store/appStore';
import * as LocalCacheActionType from '../store/localCache/actionTypes';

const DefaultColors = [
  '#D14040',
  '#7F40D1',
  '#2D76E5',
  '#1BBC86',
  '#E2E22D',
  '#92661A',
  '#EB9563',
  '#E5897F',
  '#E24E89',
  '#C063E8',
  '#63B3E8'
];
const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

const CheckforAutoSwitch = (result, configuration, widgetconfig, withPercent) => {
  if (result.data.length <= 1 &&
    configuration.autoGenerate.autoSwitch &&
    configuration.drillDownConfig &&
    configuration.drillDownConfig.length > 0) {
    configuration.autoGenerate.key = configuration.drillDownConfig[0].key;
    configuration.autoGenerate.title = configuration.drillDownConfig[0].title;
    configuration.drillDownConfig = configuration.drillDownConfig.filter(x => x.key !== configuration.autoGenerate.key);
    widgetconfig.configuration = JSON.stringify(configuration);
    widgetconfig.title = configuration.autoGenerate.secondLevelTitle;
    const resultRes = GetKeyValueData(result.data[0].data, configuration, withPercent, false, widgetconfig, true);
    store.dispatch({
      type: LocalCacheActionType.SET_CACHE_DATA,
      payload: { key: widgetconfig.widgetId, data: resultRes }
    });
    store.dispatch({
      type: LocalCacheActionType.SET_CACHE_DATA,
      payload: { key: widgetconfig.widgetId + 'drillconfig', data: configuration }
    });
    return resultRes;
  }
  return result;
};

const GetKeyValueData = (data, configuration, withPercent, autoSwitch = true, widgetconfig, isAutoSwitch = false) => {
  let result = GenerateKeyValueResponseData(data, configuration, withPercent, isAutoSwitch);
  if (autoSwitch && result && result.data && result.data.length > 0) {
    result = CheckforAutoSwitch(result, configuration, widgetconfig, withPercent);
  }
  return result;
};

const getAutogenerateDataColumn = (autogenerateConfig, data) => {
  if (autogenerateConfig?.dataColumn === undefined) {
    return;
  }
  const res = [];
  autogenerateConfig?.dataColumn.forEach(x => {
    const a = {};
    a.key = x.key;
    a.title = x.title;
    a.value = DataOperators[x.operator](data, x.key);
    res.push(a);
  });
  return res;
};

const GenerateKeyValueResponseData = (data, configuration, withPercent, isAutoSwitch) => {
  const resData = [];
  let totalCount = 0;
  const colors = [];

  if (configuration.isRepeated === true) {
    const filteredData = getAutoGenerateFilterData(
      data,
      configuration.autoGenerate
    );
    const b = {};
    if (configuration.trend && configuration.trend.type === 'Distinct') {
      totalCount = DataOperators.DistinctCount((filteredData || []), configuration.trend.key);
      removeDuplicates(filteredData.map((obj) => obj[configuration.autoGenerate.key]) || [])?.forEach(el => {
        b[el] = DataOperators.DistinctCount((
          (filteredData || []).filter(xf => xf[configuration.autoGenerate.key] === el) || []
        ), configuration.trend.key);
      });
    } else if (configuration.yAxiskey !== undefined && configuration.yAxiskey !== '') {
      if (configuration.operator) {
        totalCount = DataOperators[configuration.operator](filteredData, configuration.yAxiskey);
        removeDuplicates(filteredData.map((obj) => obj[configuration.autoGenerate.key]) || [])?.forEach(el => {
          b[el] = DataOperators[configuration.operator]((
            (filteredData || []).filter(xf => xf[configuration.autoGenerate.key] === el) || []
          ), configuration.yAxiskey);
        });
      } else {
        totalCount = (filteredData || []).length;
        filteredData.forEach(el => {
          b[el[configuration.autoGenerate.key]] =
            (b[el[configuration.autoGenerate.key]] || 0) + 1;
        });
      }
    } else {
      totalCount = (filteredData || []).length;
      filteredData.forEach(el => {
        b[el[configuration.autoGenerate.key]] =
          (b[el[configuration.autoGenerate.key]] || 0) + 1;
      });
    }

    Object.keys(b).map((key, ic) => {
      const color = DefaultColors[ic] || getRandomColor();
      const dataColumn = getAutogenerateDataColumn(configuration.autoGenerate, filteredData.filter(
        ele => ele[configuration.autoGenerate.key] === key
      ));
      const otherColumn = {};

      dataColumn?.forEach(xc => {
        otherColumn[xc.key] = xc.value;
      });

      colors.push(color);
      resData.push({
        attributeName: key,
        attributeValue: b[key],
        data: filteredData.filter(
          ele => ele[configuration.autoGenerate.key] === key
        ),
        keyTitle: configuration.autoGenerate.title || configuration.autoGenerate.key,
        drillDownKey: configuration.autoGenerate.key,
        ...otherColumn,
        isAutoSwitch
      });
    });
  } else if (configuration.isMappingAvailable === true) {
    data.forEach((x, ic) => {
      const color = (DefaultColors[ic] || getRandomColor());
      colors.push(color);
      resData.push({
        attributeName: x[configuration.widgetDataMapping.attributeName] || 'Unknown',
        attributeValue: x[configuration.widgetDataMapping.attributeValue],
        percentage: x[configuration.widgetDataMapping.percentage],
        keyTitle: configuration.keyTitle,
        drillDownKey: configuration?.autoGenerate?.key,
        ...x
      });
    });
    if (((configuration || {}).widgetDataMapping || {}).percentage) {
      return { data: resData, colors: colors, isAutoSwitch };
    }
  } else {
    const columns = configuration.columns.sort(
      (a, b) => (a.sortOrder || 0) - (b.sortOrder || 0)
    );
    columns.map((item, ic) => {
      const filters = item.filters;
      let count = 0;
      let columnData = data || [];
      filters.forEach(element => {
        const result = columnData.filter(function (v, i) {
          return (
            v[element.key] !== null &&
            v[element.key] !== undefined &&
            ((element.operator === undefined &&
              element.values
                .find(value => value.toString() === (v[element.key] || '').toString()) !==
              undefined) || (
              element.operator !== undefined &&
                executeOperator(element, v) === true
            )
            ));
        });
        columnData = result;
      });
      const itemkey = configuration.yAxiskey ? configuration.yAxiskey : item.key;
      if (configuration.operator) {
        const res = DataOperators[configuration.operator](columnData, itemkey) || 0;
        count = count + res;
      } else {
        count = count + removeDuplicates(((columnData || []).map((o) => o[itemkey]) || [])).length;
      }
      totalCount += count;
      columnData.forEach(xi => {
        xi.attributeValue = item.name;
      });
      const color = item.color || (DefaultColors[ic] || getRandomColor());
      colors.push(color);
      resData.push({
        attributeName: item.name || 'Unknown',
        attributeValue: count,
        data: columnData,
        keyTitle: configuration.keyTitle,
        drillDownKey: filters
      });
    });
  }
  if (withPercent) {
    for (let i = 0; i < resData.length; i++) {
      resData[i].percentage = Math.round(
        (resData[i].attributeValue / totalCount) * 100
      );
    }
    return { data: resData, colors: colors, isAutoSwitch };
  }
  return resData;
};

const GetDownloadData = (data, configuration) => {
  let resData = [];
  const columns = configuration.columns;
  if (configuration.isRepeated === true) {
    resData = getAutoGenerateFilterData(data, configuration.autoGenerate);
  } else {
    if (columns === undefined) return data || [];
    columns.map((item, ic) => {
      const filters = item.filters;
      let columnData = data || [];
      filters.forEach(element => {
        const result = columnData.filter(function (v, i) {
          return (
            v[element.key] !== null &&
            v[element.key] !== undefined &&
            ((element.operator === undefined &&
              element.values
                .find(value => value.toString() === (v[element.key] || '').toString()) !== undefined) || (
              element.operator !== undefined &&
                executeOperator(element, v) === true)
            )
          );
        });
        columnData = result;
      });
      resData = [...resData, ...columnData];
    });
  }
  return resData;
};

const totalCount = (array, key) => {
  return array.reduce((r, a) => {
    return r + a[key];
  }, 0);
};

const GetValidValue = (value, seriesItem, type) => {
  let isValid = false;
  switch (type) {
    case 'Month':
    case 'Week':
      if (moment(value).format('MM/DD/YY') === seriesItem.label) {
        isValid = true;
      }
      break;
    case 'Day':
      //  object[type] = month.label;
      if (moment(value).format('H') === seriesItem.start) {
        isValid = true;
      }
      break;
    case 'YTD':
      if (moment(value).format('MMM YY') === seriesItem.label) {
        isValid = true;
      }
      break;

    default:
      isValid = value === seriesItem.label;
      break;
  }
  return isValid;
};
const GetChartData = (
  data,
  configuration,
  startDate,
  endDate,
  type = 'YTD',
  operation = 'count'
) => {
  const columns = configuration.columns;
  const resData = [];

  if (configuration.isRepeated === true) {
    data = getAutoGenerateFilterData(data, configuration.autoGenerate) || [];
  }

  type = configuration.trend.type
    ? configuration.trend.type
    : moment(startDate).format('YYYY') === moment(endDate).format('YYYY') &&
      moment(startDate).format('MM') === moment(endDate).format('MM')
      ? 'Month'
      : 'YTD';

  const mainAccessor = type === 'Month' || type === 'YTD'
    ? getSeries(startDate, endDate, type)
    : getDistinctByProperty(data, configuration.trend.key).map((x) => ({
      label: x[configuration.trend.key],
      start: startDate,
      end: endDate
    }));

  const CharAccessor = {};
  CharAccessor.mainAccessor = type;
  const colors = [];
  const barKeys = [];
  const barColors = [];
  const legends = [];

  mainAccessor.map(month => {
    const object = {};

    object[type] = month.label;

    object.seriesItem = month;
    if (configuration.isRepeated === true && (configuration.autoGenerate.dataColumn === undefined || configuration.autoGenerate.dataColumn.length === 0)) {
      const b = {};
      data.forEach(el => {
        const isValid = GetValidValue(
          el[configuration.trend.key],
          month,
          type,
          operation
        );
        if (operation === 'Max') {
          if (isValid) {
            b[el[configuration.autoGenerate.key]] =
              (b[el[configuration.autoGenerate.key]] || 0) + 1;
          } else {
            b[el[configuration.autoGenerate.key]] =
              b[el[configuration.autoGenerate.key]] || 0;
          }
        } else {
          if (isValid) {
            b[el[configuration.autoGenerate.key]] =
              (b[el[configuration.autoGenerate.key]] || 0) + 1;
          } else {
            b[el[configuration.autoGenerate.key]] =
              b[el[configuration.autoGenerate.key]] || 0;
          }
        }
      });

      Object.keys(b).map((key, ic) => {
        CharAccessor['line' + ic] = key;
        const color = DefaultColors[ic] || getRandomColor();
        colors.push(color);
        if (barKeys.find(value => value === key) === undefined) {
          barColors.push(color);
          barKeys.push(key);
          legends.push({ label: key, color: color });
        }

        object[key] = b[key];
        colors[key] = color;
      });
    } else if (configuration.isRepeated === true && configuration.autoGenerate.dataColumn !== undefined) {
      configuration.autoGenerate.dataColumn.map((item, index) => {
        CharAccessor['line' + index] = item.title;
        let count = 0;
        let columnData = data || [];
        columnData = data.filter(x => x[configuration.autoGenerate.key] === month.label);
        count = DataOperators[item.operator](columnData, item.key);
        const color = item.color || (DefaultColors[index] || getRandomColor());
        if (barKeys.find(value => value === item.name) === undefined) {
          barColors.push(color);
          barKeys.push(item.title);
          legends.push({ label: item.title, color: color });
        }

        object[item.title] = count;
        colors[item.title] = color;
      });
    } else {
      (columns || []).map((item, index) => {
        CharAccessor['line' + index] = item.name;

        const filters = item.filters;
        let count = 0;
        const columnData = data || [];
        let filterResult = [...columnData];
        filters.forEach(element => {
          const result = filterResult.filter(function (v, i) {
            return (
              ((element.operator === undefined &&
                element.values
                  .find(value => value.toString() === (v[element.key] || '').toString()) !== undefined) || (
                element.operator !== undefined &&
                  executeOperator(element, v) === true)
              )
            );
          });
          filterResult = [...result];
        });

        count = filterResult.reduce((sum, currentValue) => {
          const isValid = GetValidValue(
            currentValue[configuration.trend.key],
            month,
            type
          );
          if (operation === 'Max') {
            if (isValid) {
              return (sum || 0) > currentValue.Value
                ? sum
                : el.Value || 0;
            } else {
              return sum;
            }
          } else {
            if (isValid) {
              return sum + 1;
            } else {
              return sum;
            }
          }
        }, 0);
        const color = item.color || (DefaultColors[index] || getRandomColor());
        if (barKeys.find(value => value === item.name) === undefined) {
          barColors.push(color);
          barKeys.push(item.name);
          legends.push({ label: item.name, color: color });
        }

        object[item.name] = count;
        colors[item.name] = color;
      });
    }
    resData.push(object);
  });
  return {
    chartAccessor: CharAccessor,
    data: resData,
    colors: colors,
    barKeys: barKeys,
    barColors: barColors,
    legends
  };
};

const getAutoGenerateFilterData = (data, autoGenerateconfig) => {
  let filteredData = (data || []).filter(x => {
    return (
      x[autoGenerateconfig.key] !== undefined &&
      x[autoGenerateconfig.key] !== null
    );
  });
  (autoGenerateconfig.filters || []).forEach(element => {
    const result = (filteredData || []).filter(function (v, i) {
      return (
        v[element.key] !== null &&
        v[element.key] !== undefined &&
        ((element.operator === undefined &&
          element.values
            .find(value => value.toString() === (v[element.key] || '').toString()) !== undefined) || (
          element.operator !== undefined &&
            executeOperator(element, v) === true)
        )
      );
    });
    filteredData = result;
  });
  return filteredData;
};

const getSeries = (startDateValue, endDateValue, type) => {
  const result = [];
  const startDate = moment(startDateValue);
  const endDate = moment(endDateValue);

  switch (type) {
    case 'Month':
    case 'Week':
      while (startDate.isBefore(endDate)) {
        result.push({
          label: startDate.format('MM/DD/YY'),
          start: startDate.startOf('day').format(),
          end: startDate.endOf('day').format()
        });
        startDate.add(1, 'day');
      }
      result.push({
        label: endDate.format('MM/DD/YY'),
        start: endDate.startOf('day').format(),
        end: endDate.endOf('day').format()
      });
      break;

    case 'Day':
      for (let i = 0; i < 24; i++) {
        result.push({
          label: (i > 10 ? i : '0' + i) + ':00',
          start: i,
          end: i + 1
        });
      }
      break;
    case 'YTD':
      while (startDate.isBefore(endDate)) {
        result.push({
          label: startDate.format('MMM YY'),
          start: startDate.startOf('month').format(),
          end: startDate.endOf('month').format()
        });
        startDate.add(1, 'month');
      }
      result.push({
        label: endDate.format('MMM YY'),
        start: endDate.startOf('month').format(),
        end: endDate.endOf('month').format()
      });
      break;

    default:
      break;
  }

  return removeDuplicates(result, 'label');
};
const GetPropsForData = (type, responseData, widgetconfig, summaryData) => {
  // Change this function to change view data
  let data = [];
  let columns = [];
  let configuration;
  if (
    widgetconfig.isConfigurable &&
    (widgetconfig.configuration || '') !== ''
  ) {
    configuration = JSON.parse(
      JSON.stringify(widgetconfig.configuration)
    );
    configuration = camelcaseKeys(JSON.parse(configuration));
  }
  if (type === 'summary') {
    data = summaryData;
    if (widgetconfig.isConfigurable && widgetconfig.widgetType === 3) {
      columns = configuration.columns;
    }
  } else {
    if (
      widgetconfig.isConfigurable &&
      (widgetconfig.configuration || '') !== ''
    ) {
      // columns = configuration.columns;
      data = GetDownloadData(responseData, configuration);
    } else {
      data = responseData;
    }
  }

  if (columns.length === 0 && (data || []).length > 0) {
    Object.keys(data[0] || {}).map(key => {
      if (key !== 'seriesItem') {
        let nameValue = key;
        if (data && data[0] && data[0].drillDownKey && data[0].keyTitle && key === 'attributeName') {
          nameValue = data[0].keyTitle;
        } else if ((configuration || {}).summaryFieldsConfig && configuration.summaryFieldsConfig[key]) {
          nameValue = configuration.summaryFieldsConfig[key];
        }
        columns.push({ key: key, name: nameValue, dataFormat: (isNaN(data[0][key]) ? 'Text' : 'Number') });
      }
    });
  }

  return {
    data: data,
    columns: columns,
    config: {}
  };
};

const GetPropsForComparisionData = (
  comparisonLayouts,
  widgetconfig,
  renderChildTable,
  pageSize = 10
) => {
  const data = [];
  const columns = [];
  let isKeyValue = true;

  if (comparisonLayouts === undefined || comparisonLayouts.length <= 0) {
    return {
      data: data,
      columns: columns
    };
  }
  const accessor = comparisonLayouts[0].layoutComponent.accessor;
  const layoutComponent =
    (
      comparisonLayouts.filter(
        x => ((x.layoutComponent || {}).keys || []).length > 0
      )[0] || {}
    ).layoutComponent || {};
  const keys = layoutComponent.keys || [];
  let unit = layoutComponent.unit || '';
  if (unit === null || unit === 'null') {
    unit = '';
  }
  isKeyValue = comparisonLayouts[0].layoutComponent.isKeyValue;

  if (isKeyValue === true) {
    columns.push({ key: 'property', name: 'Data center' });
    comparisonLayouts[0].layoutComponent.data.forEach(dataPoint => {
      columns.push({
        key: dataPoint.attributeName,
        name: dataPoint.attributeName
      });
    });
  } else {
    columns.push({ key: accessor, name: '' });
    columns.push({
      key: 'child',
      name: layoutComponent.xAxisLabel,
      renderComponent: renderChildTable
    });
  }
  if (isKeyValue === true) {
    comparisonLayouts.forEach(comObj => {
      const obj = {};
      obj.property = comObj.propertyName;
      comObj.layoutComponent.data.forEach(
        x => (obj[x.attributeName] = x.attributeValue)
      );
      data.push(obj);
    });
  } else {
    comparisonLayouts[0].layoutComponent.data.forEach(dataPoint => {
      const obj = {};
      obj[accessor] = dataPoint[accessor];
      obj.child = '';
      data.push(obj);
    });
    const childColumn = [];

    childColumn.push({ key: 'property', name: 'Data center' });
    keys.forEach(key => {
      childColumn.push({
        key: key,
        name: key
      });
    });
    data.forEach(item => {
      const childData = [];
      (comparisonLayouts || []).forEach(comObj => {
        const obj = {};
        obj.property = comObj.propertyName;
        (keys || []).forEach(key => {
          obj[key] =
            (((((comObj || {}).layoutComponent || {}).data || []).find(
              x => x[accessor] === (item || {})[accessor]
            ) || {})[key] || 0) +
            ' ' +
            unit;
        });

        childData.push(obj);
      });
      item.child = {
        columns: [...childColumn],
        data: [...childData],
        config: { convertToNumber: true }
      };
    });
  }
  return {
    data: data,
    columns: columns,
    config: { pageSize: pageSize, convertToNumber: true }
  };
};

const getYAxisLabel = (yAxisLabel, svg, y, x, angle) => {
  return svg
    .append('text')
    .attr('transform', 'rotate(' + angle + ')')
    .attr('y', y)
    .attr('x', x)
    .attr('dy', '1em')
    .style('text-anchor', 'middle')
    .style('font-family', 'roboto')
    .style('font-size', '0.75em')
    .style('font-weight', '500')
    .style('fill', '#000000')
    .style('text-transform', 'capitalize')
    .text(yAxisLabel || 'count');
};

const getNoDataFoundLabel = (range, svg, y, x) => {
  return (
    svg
      .append('g')
      .attr('transform', 'translate(' + 3 * (x / 4) + ',' + y + ')')
      .append('text')
      // .attr("y", y)
      // .attr("x", x)

      .style('text-anchor', 'middle')
      .style('font-family', 'roboto')
      .style('font-size', '0.86em')
      .style('font-weight', '500')
      .style('fill', '#000000')
      .text(
        'No data available' +
        ((range || '') !== 'undefined to undefined' ? ' for ' + range : '.')
      )
  );
};
async function renderDrillDownChartOnField (chartConfig, drillDownConfig, level, divId, onDrillDown, allowDrillDown) {
  try {
    if (chartConfig.configuration.drillDownConfig.length < level) {
      level = (level - 1);
      if (drillDownConfig.defaultSettings) {
        store.dispatch({
          type: LocalCacheActionType.CLEAR_CACHE_DATA_BY_KEY,
          payload: chartConfig.widgetconfig.widgetId
        });
        store.dispatch({
          type: LocalCacheActionType.CLEAR_CACHE_DATA_BY_KEY,
          payload: chartConfig.widgetconfig.widgetId + 'drillconfig'
        });
        drillDownConfig.defaultSettings();

        if (chartConfig.configuration.showDetailsOndemand) {
          let startDate = chartConfig.startDate;
          const endDate = chartConfig.endDate;
          if (((chartConfig.configuration || {}).trend || {}).type === 'YTD') {
            startDate = moment(startDate).subtract(12, 'months').format('MM/DD/YYYY');
          }
          localStorage.removeItem(chartConfig.widgetconfig.widgetId + 'selectedConfig');
          const selected = { startDate: startDate, endDate: endDate, marketName: null };
          localStorage.setItem(chartConfig.widgetconfig.widgetId + 'selectedConfig', JSON.stringify(selected));
        }
      }
      return;
    }
    if (chartConfig.configuration.showDetailsOndemand === true) {
      chartConfig.configuration.keyTitle = chartConfig.configuration.drillDownConfig[level - 1].title;
    }

    const resData = chartConfig.configuration.showDetailsOndemand !== true
      ? GetKeyValueData((chartConfig.data.find(a => a.attributeName === drillDownConfig.config.find((x) => x.level === level + 1).key) ||
        {}).data, {
        isRepeated: true,
        trend: chartConfig.configuration.trend,
        operator: chartConfig.configuration.operator,
        yAxiskey: chartConfig.configuration.yAxiskey,
        yAxisLabel: chartConfig.configuration.yAxisLabel,
        autoGenerate: {
          key: chartConfig.configuration.drillDownConfig[level - 1].key,
          title: chartConfig.configuration.drillDownConfig[level - 1].title,
          filters: [],
          dataColumn: chartConfig.configuration?.autoGenerate?.dataColumn
        },
        summaryFieldsConfig: { attributeName: chartConfig.configuration.drillDownConfig[level - 1].title }
      }, true)
      : GetKeyValueData(await getOnDemandData(chartConfig,
        chartConfig.data.find(a => a.attributeName === drillDownConfig.config.find((x) => x.level === level + 1).key)
        , chartConfig.configuration.drillDownConfig[level - 1].key), chartConfig.configuration, true)
      ;
    if (drillDownConfig.currentLevel === level + 1) {
      drillDownConfig.isDrillDown = false;
    }
    const drillData = [];
    resData?.data?.forEach(x => {
      const y = cloneDeep(x);
      y.data = null;
      drillData.push(y);
    });

    const config = {
      widgetId: chartConfig.widgetId,
      usersWidgetMappingId: chartConfig.usersWidgetMappingId,
      widgetconfig: chartConfig.widgetconfig,
      startDate: chartConfig.startDate,
      endDate: chartConfig.endDate,
      configuration: chartConfig.isRepeated === true
        ? {
            isRepeated: true,
            autoGenerate: {
              key: chartConfig.configuration.drillDownConfig[level - 1].key,
              filters: [],
              dataColumn: chartConfig.configuration.autoGenerate.dataColumn
            },
            drillDownConfig: chartConfig.configuration.drillDownConfig
          }
        : chartConfig.configuration,
      drillDowndata: drillData,
      rawData: chartConfig.rawData,
      data: resData.data,
      yAxisLabel: chartConfig.configuration.yAxisLabel ?? 'count',
      type: 'BarChart',
      keys: resData.barKeys,
      colors: resData.colors
    };
    BarChartUtility(
      config,
      divId,
      onDrillDown,
      drillDownConfig,
      level + 1,
      allowDrillDown
    );
  } catch (error) {
    // console.log(error);
    if (drillDownConfig.defaultSettings) {
      drillDownConfig.defaultSettings();
    }
  }
}

async function getOnDemandData (widgetConfig
  , selected, key) {
  localStorage.removeItem(widgetConfig.widgetId + 'selectedConfig');
  localStorage.setItem(widgetConfig.widgetId + 'selectedConfig', JSON.stringify(selected));
  return new Promise(function (resolve, reject) {
    const arg = [{ key: 'startDate', value: selected.startDate },
      { key: 'endDate', value: selected.endDate },
      { key: 'key', value: key },
      { key: 'marketName', value: selected.marketName }
      // { key: 'departmentName', value: selected.departmentName },
    ];
    apiBatchRequest([{
      url: createApiUrl(buildWidgetUrlWithParameter(widgetConfig.widgetconfig.dataUrl, arg)),
      // postBody: [],
      key: 'response'
    }]).then(({ response }) => {
      return resolve(response.data);
    }).catch(() => {
      return resolve([]);
    });
  });
}
export {
  GetKeyValueData,
  GetDownloadData,
  GetPropsForData,
  GetChartData,
  getYAxisLabel,
  getNoDataFoundLabel,
  GetPropsForComparisionData,
  renderDrillDownChartOnField
};
function executeOperator (element, v) {
  return (Operators[element.operator](
    (v[element.key] || '').toString(),
    (element.operator === 'In' ||
      element.operator === 'Between' ||
      element.operator === 'BetweenInclusive' ||
      element.operator === 'NotIn'
      ? element.values
      : element.values[0]))).result === true;
}
